export const svgIcons = {
  eyeOpen: `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" fill="none"/>
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
    </svg>
  `,

  eyeClosed: `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m1 1 22 22" stroke="currentColor" stroke-width="2"/>
      <path d="M6.71 6.71C4.98 8.07 3.78 10.15 3 12c1.33 3.16 4.77 6 9 6 1.55 0 3.06-.44 4.27-1.18" stroke="currentColor" stroke-width="2" fill="none"/>
      <path d="M10.54 5.07A10.81 10.81 0 0 1 12 5c4.23 0 7.67 2.84 9 6-.18.43-.39.84-.63 1.23" stroke="currentColor" stroke-width="2" fill="none"/>
      <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" stroke="currentColor" stroke-width="2" fill="none"/>
    </svg>
  `,

  eyeOpenSmall: `
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" fill="none"/>
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
    </svg>
  `,

  eyeClosedSmall: `
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m1 1 22 22" stroke="currentColor" stroke-width="2"/>
      <path d="M6.71 6.71C4.98 8.07 3.78 10.15 3 12c1.33 3.16 4.77 6 9 6 1.55 0 3.06-.44 4.27-1.18" stroke="currentColor" stroke-width="2" fill="none"/>
      <path d="M10.54 5.07A10.81 10.81 0 0 1 12 5c4.23 0 7.67 2.84 9-.18.43-.39.84-.63 1.23" stroke="currentColor" stroke-width="2" fill="none"/>
      <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" stroke="currentColor" stroke-width="2" fill="none"/>
    </svg>
  `,

  mapLayers: `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="12,2 2,7 12,12 22,7 12,2" stroke="currentColor" stroke-width="2" fill="none"/>
      <polyline points="2,17 12,22 22,17" stroke="currentColor" stroke-width="2"/>
      <polyline points="2,12 12,17 22,12" stroke="currentColor" stroke-width="2"/>
    </svg>
  `,

  legend: `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="8" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2"/>
      <line x1="8" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="2"/>
      <line x1="8" y1="18" x2="21" y2="18" stroke="currentColor" stroke-width="2"/>
      <line x1="3" y1="6" x2="3.01" y2="6" stroke="currentColor" stroke-width="2"/>
      <line x1="3" y1="12" x2="3.01" y2="12" stroke="currentColor" stroke-width="2"/>
      <line x1="3" y1="18" x2="3.01" y2="18" stroke="currentColor" stroke-width="2"/>
    </svg>
  `,

  expand: `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polyline points="15,3 21,3 21,9" stroke="currentColor" stroke-width="2"/>
      <polyline points="9,21 3,21 3,15" stroke="currentColor" stroke-width="2"/>
      <line x1="21" y1="3" x2="14" y2="10" stroke="currentColor" stroke-width="2"/>
      <line x1="3" y1="21" x2="10" y2="14" stroke="currentColor" stroke-width="2"/>
    </svg>
  `,

  shrink: `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polyline points="4,14 10,14 10,20" stroke="currentColor" stroke-width="2"/>
      <polyline points="20,10 14,10 14,4" stroke="currentColor" stroke-width="2"/>
      <line x1="14" y1="10" x2="21" y2="3" stroke="currentColor" stroke-width="2"/>
      <line x1="3" y1="21" x2="10" y2="14" stroke="currentColor" stroke-width="2"/>
    </svg>
  `,

  draw: `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 19l7-7 3 3-7 7-3-3z" stroke="currentColor" stroke-width="2" fill="none"/>
      <path d="m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" stroke="currentColor" stroke-width="2" fill="none"/>
      <path d="m2 2 7.586 7.586" stroke="currentColor" stroke-width="2"/>
      <circle cx="11" cy="11" r="2" stroke="currentColor" stroke-width="2" fill="none"/>
    </svg>
  `,
};
